import VideoSlideshowDesignerView from './VideoSlideshowDesignerView';

export default VideoSlideshowDesignerView;
